$(document).foundation();
import './gift-navbar';
import './post_messages';

$('.even-height').each(function() {
    $(this).children().children().children('.even-height-item').matchHeight();
});

$('#mobile-nav-icon').click(function(){
    $(".nav-main-mobile ul.level-one").slideToggle("slow");
    $('#mobile-nav-icon').toggleClass('open');
});
$('.nav-main-mobile ul').click(function(){
    $('#mobile-nav-icon').toggleClass('open');
    $(".nav-main-mobile ul.level-one" ).slideToggle("fast");
});

$(".openWin").click(function(e){
    e.preventDefault();
    var url = $(this).attr('href');
    var windowName = 'Gift';
    window.open(url, windowName, "height=620,width=800");
});

$('#signup_form').validate({
    rules: {
        amount: {
            required: true,
            number: true
        },
        name: {
            required: true
        },
        email: {
            required: true,
            email: true
        },
        phone: {
            required: true
        }
    },
    submitHandler: function(form) {
        $.ajax({
            url: "/cf-signup.php",
            type: "POST",
            data: $(form).serialize(),
            cache: false,
            success: function(data){
                console.log(data);
                if(data == 'SUCCESS') {
                    $(".signup_response").show();
                    $('#signup_form')[0].reset();
                }
            }
        });
    }
});

$(window).on('load', function() {
    const overlay = document.querySelector('.gift-overlay');
    const modalNavbar = document.querySelector('.js-gift-modal-navbar');
    const modal = document.getElementById('gift-modal');
    const openIframeBtn = document.getElementById('open-modal-btn');
    const closeIframeBtn = overlay && overlay.querySelector('.close');
    const iframe = document.getElementById('donation-iframe');
    
    const confirmToClose = overlay && overlay.querySelector('.close-confirmation');
    const confirmModalTitle = confirmToClose && confirmToClose.querySelector('.js-close-title');
    const confirmModalYesBtn = confirmToClose && confirmToClose.querySelector('.js-close');
    const confirmModalNoBtn = confirmToClose && confirmToClose.querySelector('.js-not-close');

    const online_gift_btns = document.querySelectorAll('#online_gift_btn');
    const memorial_gift_btns = document.querySelectorAll('#memorial_gift_btn');
    const anniversary_gift_btns = document.querySelectorAll('#anniversary_gift_btn');
    const monthly_debit_btns = document.querySelectorAll('#monthly_debit_btn');

    function isIPhoneDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
        // Check if the user agent indicates an iPhone device (any version)
        const isIPhone = /iPhone/.test(userAgent);
    
        if (isIPhone) {
            console.log("Detected iPhone device");
            return true;
        }
        
        console.log("Not an iPhone device");
        return false;
    }

    console.log(isIPhoneDevice(), 'version is higher');

    if (isIPhoneDevice()) {
        const button = document.getElementById('open-modal-btn');
        if (button) {
            const link = document.createElement('a');
            link.href = "/newflow/gift.php"; // Set your desired link
            link.textContent = "Ge en gåva";  // Same text as the button
            link.className = "e-button blue"; // Same classes as the button
            link.style.padding = "20px";
            link.target = "_blank"; // Open in a new tab
            link.rel = "noopener noreferrer"
            button.replaceWith(link); // Replace the button with the link
        }
    }

    online_gift_btns.forEach(online_gift_btn => {
        online_gift_btn.addEventListener('click', () => {
            if(isIPhoneDevice()) {
                window.location.href = "/newflow/gift.php";
            } else {
            iframe.src = `${window.location.origin}/newflow/gift.php`;
                openIframe('gift');
            }
        })
    });

    memorial_gift_btns.forEach(memorial_gift_btn => {
        memorial_gift_btn.addEventListener('click', () => {
            if(isIPhoneDevice()) {
                window.location.href = "/newflow/memorialGift.php?type=1";
            } else {
                iframe.src = `${window.location.origin}/newflow/memorialGift.php?type=1`;
                openIframe('memorial');
            }
        })
    });

    anniversary_gift_btns.forEach(anniversary_gift_btn => {
        anniversary_gift_btn.addEventListener('click', () => {
            if(isIPhoneDevice()) {
                window.location.href = "/newflow/memorialGift.php?type=2";
            } else {
                iframe.src = `${window.location.origin}/newflow/memorialGift.php?type=2`;
                openIframe('anniversary');
            }
        })
    });

    monthly_debit_btns.forEach(monthly_debit_btn => {
      monthly_debit_btn.addEventListener('click', () => {
            if(isIPhoneDevice()) {
                window.location.href = "/newflow/monthlydebit";
            } else {
                iframe.src = `${window.location.origin}/newflow/monthlydebit.php`;
                openIframe('monthlyDebit');
            }
        })
    });

    if (openIframeBtn) {
        openIframeBtn.addEventListener('click', () => {
            openIframe('gift');
        });
    }
    
    const openIframe = (gitType) => {
        modal.style.display = 'block';
        overlay.style.display = 'block';
        modalNavbar.style.display = 'flex';
        document.body.classList.add('no-scroll');
        if (gitType === 'gift') {
            // iframe.src = `${window.location.origin}/newflow/gift.php`;
            overlay.classList.remove('memorial-gift');
          } else if (gitType === 'monthlyDebit') {
          // iframe.src = `${window.location.origin}/newflow/monthlydebit.php`;
          overlay.classList.remove('memorial-gift');
        } else {
            overlay.classList.add('memorial-gift');
        }
    }

    history.pushState(null, null, window.location.pathname + window.location.search);
    const handlePopState = (event) => {
        if ($('.gift-overlay').css('display') === 'none') {
            localStorage.removeItem('thanks')
            localStorage.removeItem('payment')
            history.pushState(null, null, window.location.pathname + window.location.search);
        }
        if ((localStorage.getItem('payment') || localStorage.getItem('thanks')) && $('.gift-overlay').css('display') !== 'none') {
            event.preventDefault();
            history.pushState(null, null, window.location.href);
            openConfirmation();
        }
    }

    window.addEventListener('popstate', (e) => handlePopState(e));

    // Close the modal when clicking outside of it
    if (closeIframeBtn) {
        closeIframeBtn.addEventListener('click', () => {
            const isThankyouPage = overlay.classList.contains('thanks-page')
            if (isThankyouPage) {
                handleCloseIframe();
            } else {
                openConfirmation();
            }
        });
    }
    
    if (confirmModalNoBtn) {
        confirmModalNoBtn.addEventListener('click', () => {
            closeConfirmation();
            delete confirmToClose.dataset.giftType;
        });
    }
    
    if (confirmModalYesBtn) {
        confirmModalYesBtn.addEventListener('click', () => {
            const giftType = confirmToClose.dataset.giftType;
            closeConfirmation();
            if (confirmModalTitle.textContent.includes("gåvotyp") && giftType) {
                changeGiftType(giftType);
                if (giftType === 'type-foretag') {
                    window.location.href = '/ge-en-gava/foretagsgava';
                }
                // overlay.classList.remove('memorial-gift--mobile');
            } else {
                handleCloseIframe();
            }
        });
    }
    
    const handleCloseIframe = () => {
        overlay.scrollTo(0, 0)
        iframe.src = iframe.src;
        modal.style.display = 'none';
        overlay.style.display = 'none';
        modalNavbar.style.display = 'none';
        document.body.classList.remove('no-scroll');

        if (localStorage.getItem('payment') || localStorage.getItem('thanks')) {
            window.removeEventListener('popstate', handlePopState);
            localStorage.removeItem('payment')
            setTimeout(() => {
                history.go(-1)
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }, 50);
            setTimeout(() => {
                history.go(-2)
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }, 150);

            if (localStorage.getItem('thanks')) {
                setTimeout(() => {
                    history.go(-3)
                    history.replaceState(null, null, window.location.pathname + window.location.search);
                }, 200);
                localStorage.removeItem('thanks')
            }

            // history.replaceState(null, null, window.location.href);
        }
    
        // overlay.classList.remove('memorial-gift--mobile');
        $('.confirm-preview-footer').hide();
    }
    
    const openConfirmation = () => {
        confirmToClose.style.display = 'block';
        overlay.style.overflow = 'hidden';
        confirmModalTitle.textContent = "Vill du avbryta din gåva?";
        confirmModalYesBtn.textContent = "Ja, avbryt";
        confirmModalNoBtn.textContent = "Nej";
    }

    const closeConfirmation = () => {
        confirmToClose.style.display = 'none';
        overlay.style.overflowY = 'auto'
    }

    const changeGiftType = (giftType) => {
        iframe.contentWindow.postMessage({changeGiftType: true, giftType}, '*')
    }
})

$('#donation-iframe').load(function() {
    const iframe = document.getElementById('donation-iframe');
    const isMemorialPage = (this.contentWindow.location.href).includes('memorialGift');
    
    const overlay = document.querySelector('.gift-overlay');
    
    if (isMemorialPage) {

        const observer = new MutationObserver((mutation) => {
            const iframeWrapper = mutation[0].target;
            const isMobile = iframeWrapper && iframeWrapper.classList.contains('mobile-view')

            if (isMobile) {
                // overlay.classList.add('memorial-gift--mobile')
            } else {
                // overlay.classList.remove('memorial-gift--mobile');
            }
        })
        
        observer.observe(iframe.contentWindow.document.body.children[0], {
            attributes : true,
            attributeFilter : ['style', 'class']
        });
        
    }
})



// WEBPACK FOOTER //
// ./_src/js/main.js